import { Injectable } from '@angular/core';
import { MsalService } from './index';

@Injectable({
  providedIn: 'root'
})
export class MsalBootstrapService {

  constructor(private msalService: MsalService) { }

  async initialize(): Promise<void> {
    try {
      const result = await this.msalService.instance.handleRedirectPromise();

      if (result && result.account) {
        this.msalService.instance.setActiveAccount(result.account);
        return;
      }

      const accounts = this.msalService.instance.getAllAccounts();

      if (accounts.length > 0) {
        this.msalService.instance.setActiveAccount(accounts[0]);
        return;
      }

      await this.msalService.loginRedirect();
    } catch (error) {
      console.error('MSAL Initialization Failed', error);
      await this.msalService.loginRedirect();
    }
  }

}

